import BaseAbility from 'umg-ember-backend/abilities/base';

export default class MlpAbility extends BaseAbility {}
